// extracted by mini-css-extract-plugin
export default {"inputLabel":"MultipleSelect_inputLabel__4DoDS","mainContainer":"MultipleSelect_mainContainer__fD5xc"};